import { render } from "./ImplantacoesInfo.vue?vue&type=template&id=16adede6&scoped=true&ts=true"
import script from "./ImplantacoesInfo.vue?vue&type=script&lang=ts"
export * from "./ImplantacoesInfo.vue?vue&type=script&lang=ts"

import "./ImplantacoesInfo.vue?vue&type=style&index=0&id=16adede6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16adede6"]])

export default __exports__